module.exports = __webpack_public_path__ + "static/media/heroimage_igib-022.97d54bf4.jpg";